// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button[theme='primary'] {
  color: #206dd2;
  transition:
    color 200ms ease,
    border-color 200ms ease;
}
  button[theme='primary']:hover {
    color: #00429d;
    border-color: #00429d;
  }
  button[theme='primary']:active {
    color: #00254d;
    border-color: #00254d;
  }
  button[theme='primary'] .loader .background {
      background: #93d0ff;
    }
  button[theme='primary'] .loader .line1,
    button[theme='primary'] .loader .line2 {
      background: #206dd2;
    }

button[theme='grey'] {
  color: #424242;
  transition:
    color 200ms ease,
    border-color 200ms ease;
}

button[theme='grey']:hover {
    color: #353535;
    border-color: #353535;
  }

button[theme='grey']:active {
    color: #0d0d0d;
    border-color: #0d0d0d;
  }

button[theme='grey'] .loader .background {
      background: #ababab;
    }

button[theme='grey'] .loader .line1,
    button[theme='grey'] .loader .line2 {
      background: #424242;
    }
:host {
  --loader-duration: 1.8s;

  display: contents;
}

button {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 28px;
  padding: 0;
  overflow: clip;
  font-weight: 700;
  text-wrap: nowrap;
  cursor: pointer;
  background: none;
  border: 0 solid;
}

button:hover:not(.loading), button:active:not(.loading) {
      border-bottom-width: 2px;
    }

button .main {
    display: flex;
    gap: calc(.25rem);
    align-items: center;

    height: calc(1.5rem);
  }

button.loading {
    cursor: wait;
  }

.loader {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.loader .loader-inner {
    position: relative;
  }

@keyframes line1 {
    0% {
      left: -100%;
      width: 100%;
    }
    100% {
      left: 100%;
      width: 10%;
    }
  }

@keyframes line2 {
    0% {
      left: -150%;
      width: 100%;
    }
    100% {
      left: 100%;
      width: 10%;
    }
  }

.loader .line1,
  .loader .line2,
  .loader .background {
    position: absolute;
    bottom: 0;
    width: 100%;

    height: calc(.25rem);
    transition: background 200ms ease;
  }

.loader .line1 {
    animation: line1 var(--loader-duration) infinite ease-out;
  }

.loader .line2 {
    animation: line2 var(--loader-duration) infinite ease-in;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
